import gql from 'graphql-tag';

const GET_CATEGORIES = gql`
    query getCategories ($action: String!) {
        getCategories (action: $action) {
        message,
        status,
        data {
            categoryId,
            name
        }
        }
    }
`;

export default GET_CATEGORIES;
